import { AvailabilityZonesUtils } from 'infra/helpers/availabilityZonesUtils';
import React from 'react';
import { randomHelper } from 'utils/randomHelper';

import { FieldSelect } from './FieldSelect';

const _getOptions = (availabilityZones, hasAutoOption) => {
    const autoOption = {
        text: 'Автоматически',
        value: 'auto',
        key: 'auto',
    };
    const options = availabilityZones.map(({ zoneName }) => {
        return {
            value: zoneName,
            key: zoneName,
            text: `${AvailabilityZonesUtils.getHumanReadableName(
                zoneName,
            )} (${zoneName})`,
        };
    });

    return [...(hasAutoOption ? [autoOption] : []), ...options];
};

const AvailabilityZoneSelect = ({
    availabilityZones,
    hasAutoOption,
    ...otherSelectProps
}) => (
    <FieldSelect
        {...{
            options: _getOptions(availabilityZones, hasAutoOption),
            ...otherSelectProps,
        }}
    />
);

AvailabilityZoneSelect.handleAvailabilityZoneName = ({
    availabilityZoneName,
    availabilityZones,
}) => {
    if (availabilityZoneName === 'auto') {
        return AvailabilityZoneSelect.getRandomAvailabilityZone({
            availabilityZones,
        });
    }
    return availabilityZoneName;
};

AvailabilityZoneSelect.getRandomAvailabilityZone = ({ availabilityZones }) => {
    if (availabilityZones.length) {
        const randomIndex = randomHelper.getRandomInt(
            0,
            availabilityZones.length - 1,
        );

        return availabilityZones[randomIndex].zoneName;
    }
};

export { AvailabilityZoneSelect };
